import React, { Component } from 'react';
import { Button } from '../Button/index';

import account from '../../../../assets/images/account.svg'
import dashboard from '../../../../assets/images/dashboard.svg'
import companyprofile from '../../../../assets/images/companyprofile.svg'
import exit from '../../../../assets/images/exit.svg'

import { i18nMark, withI18n } from 'lingui-react';

import './headerAssessmentManager.css';

class HeaderAssessmentManager extends Component {

  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false,
      isAdmin: false
    };
  }

  componentDidMount() {
    if (this.props.keyCloak.hasRealmRole('admin')) {
      this.setState({
        isAdmin: true
      })
    }
  }

  toggle = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }
  render() {
    return [
      <div key={1} className="header-dashboard-container">
        {
          this.props.noDropdown === true ? '' : [
            <div key={1} className="dropdown-pane">
              <Button
                text={this.props.account ? this.props.account.keyCloakIdentity.firstName + ' ' + this.props.account.keyCloakIdentity.lastName : ''}
                type='login'
                onClick={this.toggle}
              />
              <div key={2} className="dropdown-content">
                <span className="dashboard company-profile" onClick={() => this.props.history.push('/dashboard')}><img alt="" src={dashboard} /> {this.props.i18n._(i18nMark('Dashboard'))}</span>
                <span className="company-profile" onClick={() => this.props.history.push('/company')}><img alt="" src={companyprofile} /> {this.props.i18n._(i18nMark('Company Profile'))}</span>
                <span className="company-profile" onClick={() => { window.location.href = "https://id.securityselfie.ch/auth/realms/" + this.props.keyCloak.realm + "/account" }}><img alt="" src={account} /> {this.props.i18n._(i18nMark('Account Settings'))}</span>
                <span id="sign-out" className="company-profile" onClick={() => this.props.keyCloak.logout()}><img alt="" src={exit} /> {this.props.i18n._(i18nMark('Sign Out'))}</span>
              </div>
            </div>
          ]
        }
      </div>
    ];
  }
}

export default withI18n()(HeaderAssessmentManager);




// WEBPACK FOOTER //
// ./src/components/Header/components/HeaderAssessmentManager/HeaderAssessmentManager.js